import {
  BedDouble, Wifi, ConciergeBell, Dumbbell,
  Car, UtensilsCrossed, Briefcase, Baby, Sparkles,
  Sun, Waves, ShieldCheck
} from "lucide-react";

// ─── Catégories — SOURCE UNIQUE, utilisée par EquipmentsStep ET EquipmentsManager ──
export const CATEGORIES = [
  { id: "confort",   label: "Confort & Chambre",   Icon: BedDouble       },
  { id: "tech",      label: "Technologie",          Icon: Wifi            },
  { id: "services",  label: "Services",             Icon: ConciergeBell   },
  { id: "loisirs",   label: "Loisirs & Bien-être",  Icon: Dumbbell        },
  { id: "transport", label: "Transport",            Icon: Car             },
  { id: "repas",     label: "Restauration",         Icon: UtensilsCrossed },
  { id: "business",  label: "Business",             Icon: Briefcase       },
  { id: "famille",   label: "Enfants & Famille",    Icon: Baby            },
  { id: "energie",   label: "Énergie",              Icon: Sun             }, // 🆕 contexte Comores (coupures fréquentes)
  { id: "plage",     label: "Plage & Mer",          Icon: Waves           }, // 🆕 contexte insulaire
  { id: "securite",  label: "Sécurité",             Icon: ShieldCheck     }, // 🆕
  { id: "autre",     label: "Autre",                Icon: Sparkles        },
];

// ─── Suggestions avec catégorie pré-assignée ──────────────────────────────────
export const SUGGESTED_EQUIPMENTS = [
  { name: "Literie premium",            category: "confort"  },
  { name: "Climatisation",              category: "confort"  },
  { name: "Ventilateur",                category: "confort"  }, // 🆕
  { name: "Coffre-fort",                category: "confort"  },
  { name: "Balcon",                     category: "confort"  },
  { name: "Terrasse",                   category: "confort"  }, // 🆕
  { name: "Vue sur mer",                category: "confort"  },
  { name: "Vue jardin",                 category: "confort"  }, // 🆕
  { name: "Moustiquaire",               category: "confort"  }, // 🆕
  { name: "Linge de maison fourni",     category: "confort"  }, // 🆕

  { name: "WiFi gratuit",               category: "tech"     },
  { name: "Télévision",                 category: "tech"     },
  { name: "Domotique",                  category: "tech"     },
  { name: "Prise USB",                  category: "tech"     },

  { name: "Réception 24h/24",           category: "services" },
  { name: "Conciergerie",               category: "services" },
  { name: "Blanchisserie",              category: "services" },
  { name: "Room service",               category: "services" },
  { name: "Ménage quotidien",           category: "services" },
  { name: "Bagagerie",                  category: "services" }, // 🆕

  { name: "Piscine",                    category: "loisirs"  },
  { name: "Spa",                        category: "loisirs"  },
  { name: "Salle de sport",             category: "loisirs"  },
  { name: "Tennis",                     category: "loisirs"  },
  { name: "Hammam",                     category: "loisirs"  },
  { name: "Jacuzzi privatif",           category: "loisirs"  }, // 🆕
  { name: "Massage sur demande",        category: "loisirs"  }, // 🆕

  { name: "Navette aéroport",           category: "transport" },
  { name: "Parking gratuit",            category: "transport" },
  { name: "Parking privé",              category: "transport" }, // 🆕
  { name: "Location voiture",           category: "transport" },
  { name: "Vélos disponibles",          category: "transport" },

  { name: "Restaurant",                 category: "repas"    },
  { name: "Bar",                        category: "repas"    },
  { name: "Petit-déjeuner",             category: "repas"    },
  { name: "Rooftop bar",                category: "repas"    },
  { name: "Minibar",                    category: "repas"    },
  { name: "Cuisine équipée",            category: "repas"    }, // 🆕

  { name: "Salle de conférence",        category: "business" },
  { name: "Espace coworking",           category: "business" },
  { name: "Imprimante",                 category: "business" },

  { name: "Baby-sitting",               category: "famille"  },
  { name: "Jeux enfants",               category: "famille"  },
  { name: "Lit bébé",                   category: "famille"  },
  { name: "Menu enfant",                category: "famille"  },
  { name: "Accès PMR",                  category: "famille"  }, // 🆕

  // 🆕 Énergie — pertinent contexte Comores
  { name: "Panneaux solaires",          category: "energie"  },
  { name: "Groupe électrogène",         category: "energie"  },
  { name: "Eau chaude solaire",         category: "energie"  },

  // 🆕 Plage & Mer — pertinent contexte insulaire
  { name: "Plage privée",               category: "plage"    },
  { name: "Plongée / Snorkeling",       category: "plage"    },
  { name: "Location de bateau",         category: "plage"    },
  { name: "Chaises longues / parasols", category: "plage"    },

  // 🆕 Sécurité
  { name: "Vidéosurveillance",          category: "securite" },
  { name: "Gardien 24h/24",             category: "securite" },
];

// ─── Auto-détection par mots-clés (saisie libre dans EquipmentsManager) ──────
export const CATEGORY_KEYWORDS = {
  confort:   ["literie", "clim", "coffre", "balcon", "vue", "chambre", "oreiller", "store", "ventilateur", "moustiquaire", "terrasse"],
  tech:      ["wifi", "wi-fi", "tv", "télé", "television", "usb", "domotique", "smart", "écran"],
  services:  ["réception", "concierg", "blanchiss", "room service", "ménage", "pressing", "bagag"],
  transport: ["navette", "parking", "voiture", "taxi", "aéroport", "transfert", "vélo", "scooter"],
  loisirs:   ["piscine", "spa", "sport", "salle de sport", "tennis", "golf", "hammam", "jacuzzi", "sauna"],
  repas:     ["restaurant", "bar", "petit-déjeuner", "déjeuner", "dîner", "buffet", "rooftop", "minibar", "café", "cuisine"],
  business:  ["conférence", "coworking", "bureau", "imprimante", "projecteur", "réunion", "séminaire"],
  famille:   ["baby", "bébé", "enfant", "jeux", "crèche", "poussette", "lit bébé", "menu enfant", "pmr", "accessib", "fauteuil roulant"],
  energie:   ["solaire", "panneau", "générateur", "groupe électrogène", "eau chaude"], // 🆕
  plage:     ["plage", "plongée", "snorkeling", "bateau", "chaise longue", "parasol"], // 🆕
  securite:  ["vidéosurveillance", "caméra", "gardien"],                               // 🆕
};

export function detectCategory(name) {
  const lower = name.toLowerCase();
  for (const [cat, keywords] of Object.entries(CATEGORY_KEYWORDS)) {
    if (keywords.some(kw => lower.includes(kw))) return cat;
  }
  return "autre";
}